// extracted by mini-css-extract-plugin
module.exports = {"disableOverscroll":"use-disable-overscroll_disableOverscroll__oBizF"};